import { ValidateStringInput } from "./validate-string-input.function";

/**
 * Converts input into a normalized email string, lowercasing it and trimming it.
 * @returns "Normalized" Email
 */
export function SetNormalizedEmail(email: any): string {

    if (!ValidateStringInput(email)) {
        return "";
    }

    return email.toLowerCase().trim();
}